import { api } from "./axios";

export const getSiteSettings = () => api.get("/api/site-settings").then((r) => r.data);
export const getNavigation = () => api.get("/api/navigation").then((r) => r.data);
export const getPageSections = (pageKey) => api.get(`/api/pages/${pageKey}/sections`).then((r) => r.data);
export const getPageTableColumns = (pageKey) =>
  api.get(`/api/pages/${pageKey}/table-columns`).then((r) => r.data);
export const getArticles = () => api.get("/api/articles").then((r) => r.data);
export const getNews = () => api.get("/api/news").then((r) => r.data);

export const getAdminSiteSettings = () => api.get("/api/admin/site-settings").then((r) => r.data);
export const updateAdminSiteSettings = (payload) =>
  api.put("/api/admin/site-settings", payload).then((r) => r.data);

export const getAdminNavigation = () => api.get("/api/admin/navigation").then((r) => r.data);
export const createAdminNavigationItem = (payload) =>
  api.post("/api/admin/navigation", payload).then((r) => r.data);
export const updateAdminNavigationItem = (id, payload) =>
  api.put(`/api/admin/navigation/${id}`, payload).then((r) => r.data);
export const deleteAdminNavigationItem = (id) =>
  api.delete(`/api/admin/navigation/${id}`).then((r) => r.data);
export const reorderAdminNavigationItems = (items) =>
  api.put("/api/admin/navigation/reorder", { items }).then((r) => r.data);

export const getAdminPageSections = (pageKey) =>
  api.get(`/api/admin/pages/${pageKey}/sections`).then((r) => r.data);
export const updateAdminPageSection = (pageKey, sectionKey, payload) =>
  api.put(`/api/admin/pages/${pageKey}/sections/${sectionKey}`, payload).then((r) => r.data);

export const getAdminPageTableColumns = (pageKey) =>
  api.get(`/api/admin/pages/${pageKey}/table-columns`).then((r) => r.data);
export const createAdminPageTableColumn = (pageKey, payload) =>
  api.post(`/api/admin/pages/${pageKey}/table-columns`, payload).then((r) => r.data);
export const updateAdminPageTableColumn = (pageKey, columnId, payload) =>
  api.put(`/api/admin/pages/${pageKey}/table-columns/${columnId}`, payload).then((r) => r.data);
export const deleteAdminPageTableColumn = (pageKey, columnId) =>
  api.delete(`/api/admin/pages/${pageKey}/table-columns/${columnId}`).then((r) => r.data);
export const reorderAdminPageTableColumns = (pageKey, items) =>
  api.put(`/api/admin/pages/${pageKey}/table-columns/reorder`, { items }).then((r) => r.data);
